import React, { useState, useEffect, useRef } from 'react';
import OrganizationChart from "@dabeng/react-orgchart";
import axios from "axios";
import API from '../../../middleware/API';
import {GetStoreRole} from '../../../const/constant';

//import JSONDigger from "json-digger";
//import { v4 as uuidv4 } from "uuid";
const Organization = () => {
    const orgchart = useRef();
  const datasource = {
    id: "n1",
    name: "Lao Lao",
    title: "general manager",
    children: [
      { id: "n2", name: "Bo Miao", title: "department manager" },
      {
        id: "n3",
        name: "Su Miao",
        title: "department manager",
        children: [
          { id: "n4", name: "Tie Hua", title: "senior engineer" },
          {
            id: "n5",
            name: "Hei Hei",
            title: "senior engineer",
            children: [
              { id: "n6", name: "Dan Dan", title: "engineer" },
              { id: "n7", name: "Xiang Xiang", title: "engineer" }
            ]
          },
          { id: "n8", name: "Pang Pang", title: "senior engineer" }
        ]
      },
      { id: "n9", name: "Hong Miao", title: "department manager" },
      {
        id: "n10",
        name: "Chun Miao",
        title: "department manager",
        children: [{ id: "n11", name: "Yue Yue", title: "senior engineer" }]
      }
    ]
  };
  const [ds, setDS] = useState(datasource);
  //const dsDigger = new JSONDigger(ds, "id", "children");

  const [selectedNodes, setSelectedNodes] = useState(new Set());
  const [newNodes, setNewNodes] = useState([{ name: "", title: "" }]);
  const [isEditMode, setIsEditMode] = useState(true);
  const [isMultipleSelect, setIsMultipleSelect] = useState(false);

  useEffect(() => {

    if(localStorage.getItem('current_store_id') != null){
      const role = GetStoreRole(localStorage.getItem('current_store_id'))  ;
      if(localStorage.getItem('isLogin') && localStorage.getItem('current_store_id')){
  
        axios.all([
          API.get('Permission'),
        ])
          .then(axios.spread((permissions ) => {
            if (permissions) {          
                setDS(permissions)
            }        
        }));
      }
    }
    
  },[localStorage.getItem('isLogin'), localStorage.getItem('current_store_id')]);


  const readSelectedNode = nodeData => {
    if (isMultipleSelect) {
      setSelectedNodes(prev => new Set(prev.add(nodeData)));
    } else {
      setSelectedNodes(new Set([nodeData]));
    }
  };

  const clearSelectedNode = () => {
    setSelectedNodes(new Set());
  };

  const onNameChange = (e, index) => {
    newNodes[index].name = e.target.value;
    setNewNodes([...newNodes]);
  };

  const onTitleChange = (e, index) => {
    newNodes[index].title = e.target.value;
    setNewNodes([...newNodes]);
  };

  const addNewNode = () => {
    setNewNodes(prevNewNodes => [...prevNewNodes, { name: "", title: "" }]);
  };

  const removeNewNode = index => {
    setNewNodes(prevNewNodes => {
      prevNewNodes.splice(index, 1);
      return [...prevNewNodes];
    });
  };


  const showAll = e => {
    console.log(ds)
  };

  


  return (
    <div className="edit-chart-wrapper">
      <section className="toolbar">
        <div className="action-buttons">
        <div className="selected-nodes">
          <div>
            <h4 style={{ display: "inline-block" }}>職位詳細資訊</h4>
          </div>
          <ul>
            {Array.from(selectedNodes).map(node => (
              <li key={node.id}>
                {node.title} - {node.name} 
              </li>
            ))}
          </ul>
        </div>
          <button onClick={showAll}>
            儲存變更
          </button>

        </div>
      </section>
      <OrganizationChart
        ref={orgchart}
        datasource={ds}
        collapsible={!isEditMode}
        multipleSelect={isMultipleSelect}
        onClickNode={readSelectedNode}
        onClickChart={clearSelectedNode}
        draggable={true}
      />
    </div>
  );
};

export default Organization;